/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AnalyticsSignalQuery,
  AnalyticsSignalQuery$Outbound,
  AnalyticsSignalQuery$outboundSchema,
} from "./analyticssignalquery.js";
import {
  AnalyticsSignalSelection,
  AnalyticsSignalSelection$Outbound,
  AnalyticsSignalSelection$outboundSchema,
} from "./analyticssignalselection.js";

export type SignalFindingsRequestBody = {
  comparePrevious?: boolean | undefined;
  evidence?: boolean | undefined;
  from: Date;
  peer?: AnalyticsSignalSelection | undefined;
  signalQuery: AnalyticsSignalQuery;
  to: Date;
};

/** @internal */
export type SignalFindingsRequestBody$Outbound = {
  compare_previous: boolean;
  evidence: boolean;
  from: string;
  peer?: AnalyticsSignalSelection$Outbound | undefined;
  signal_query: AnalyticsSignalQuery$Outbound;
  to: string;
};

/** @internal */
export const SignalFindingsRequestBody$outboundSchema: z.ZodMiniType<
  SignalFindingsRequestBody$Outbound,
  SignalFindingsRequestBody
> = z.pipe(
  z.object({
    comparePrevious: z._default(z.boolean(), false),
    evidence: z._default(z.boolean(), false),
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    peer: z.optional(AnalyticsSignalSelection$outboundSchema),
    signalQuery: AnalyticsSignalQuery$outboundSchema,
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
  }),
  z.transform((v) => {
    return remap$(v, {
      comparePrevious: "compare_previous",
      signalQuery: "signal_query",
    });
  }),
);

export function signalFindingsRequestBodyToJSON(
  signalFindingsRequestBody: SignalFindingsRequestBody,
): string {
  return JSON.stringify(
    SignalFindingsRequestBody$outboundSchema.parse(signalFindingsRequestBody),
  );
}
